import type {
  DocumentSchema,
  SearchResponse,
  SearchResponseHit,
} from 'typesense/lib/Typesense/Documents';

/**
 * Returns the result count from a Typesense response, handling both
 * grouped (`grouped_hits`) and ungrouped (`hits`) formats.
 */
export const getSearchResultCount = <T extends DocumentSchema>(
  page: SearchResponse<T>
): number => page.grouped_hits?.length ?? page.hits?.length ?? 0;

/**
 * Extracts hits from a Typesense response, handling both grouped and
 * ungrouped formats. Returns a flat array of hits.
 */
export const extractHits = <T extends DocumentSchema>(
  page: SearchResponse<T>
): SearchResponseHit<T>[] => {
  if (page.grouped_hits) {
    return page.grouped_hits.flatMap((group) => group.hits);
  }
  return page.hits ?? [];
};
